import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { IFieldPreferences } from '@app/components/form/services/schema-form/schema-form-interfaces';
import { I18n } from '@app/i18n/strings-keys';
import { ComponentStaticText } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/common.type';
import { merge } from 'lodash';

@Component({
  selector: 'xux-input-checkbox',
  templateUrl: 'xux-input-checkbox.component.html',
  styleUrls: ['xux-input-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxInputCheckboxComponent implements OnInit {
  @Input() public field: IFieldPreferences = {};

  public staticTextContent: ComponentStaticText = {
    checked: I18n.Common.Checked,
  };

  public ngOnInit(): void {
    this.staticTextContent = merge(
      {},
      this.staticTextContent,
      this.field?.widgetData?.i18n ?? {},
    );
  }
}
